<template>
  <div class="order__header" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <backlink class="white"/>
    <div class="order__header-title-container">
      <img src="/static/img/pictos/commande.svg" class="">
      <span v-if="detail == true">Ma commande</span>
      <span v-else>Mes commandes</span>
    </div>
  </div>
</template>

<script>


export default {
  name: "OrderHeader",
  props: [
    "detail"
  ],
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .order__header{ background-color: $color3; padding: 65px 20px 0 20px;
    .backlink{ margin-bottom: 5px; }
    .order__header-title-container{ display: flex; align-items: flex-end; }
    img{ width: 100px; margin-left: 35px; }
    span{ color: white; font-family: 'ClanFFBlack'; font-size: 25px; margin-top: 25px; text-transform: uppercase; flex: 1; text-align: right;}
  }

</style>



// WEBPACK FOOTER //
// src/components/Order/OrderHeader.vue